import { Component } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-loading-fullscreen',
  standalone: true,
  imports: [ProgressSpinnerModule],
  templateUrl: './loading-fullscreen.component.html',
  styleUrl: './loading-fullscreen.component.scss',
})
export class LoadingFullscreenComponent {}
